<form [formGroup]="registrationForm" (ngSubmit)="handleRegistration()" class="form">
  <img class="cross" src="assets/images/close.png" alt="cross" (click)="modeChange.emit()">

  <h2 class="title">{{ 'Common.Verification.title' | translate }}</h2>

  <p class="note">{{ 'Common.Verification.send' | translate }}</p>
  <div class="inner">
    <input type="text" [placeholder]="'Auth.form.verificationPlaceholder' | translate" formControlName="code"
      name="code" class="input" [class.error]="isFieldInvalid('code')" />
  </div>
  <span class="error-message" *ngIf="isFieldInvalid('code')">
    {{ getErrorMessage('code') }}
  </span>

  <div class="btn-container">
    <app-button class="btn" [text]="'Auth.form.authButton' | translate" type="submit"></app-button>
  </div>

  <div class="text-wrapper">
    <span class="text">{{ 'Common.Verification.noCode' | translate }}</span>
    <button class="link-button" type="button" (click)="handleResend()">
      {{ 'Common.Verification.resend' | translate}}
    </button>
  </div>
</form>